import React from 'react'
import qs from 'query-string'
import useSWR from 'swr'
import { useLocation } from 'react-router-dom'
import BackLink from '@/components/BackLink'
import Button from '@/components/Button'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import AddWorkForm from './components/AddWorkForm'
import { useCurrentUser, usePage } from '@/hooks'
import { IPropsParse } from './interface'
import { api } from '@/api'
import style from './styles/add.module.scss'

const AddWork = (): React.ReactElement => {
  const location = useLocation()
  const page = usePage()
  const { currentUser } = useCurrentUser()

  const { object } = page?.init_state
  const {
    contest_detail: contestDetail = '/',
    authorization = '/'
  } = page?.init_state?.global?.config
  const { contest_id: contestId = '' }: IPropsParse = qs.parse(location.search)
  const { data = {} } = useSWR({ id: contestId }, api.getContest)

  const url = `${contestDetail}?element_id=${contestId}`

  return (
    <Container>
      <Section>
        <BackLink href={url} title='Конкурс' />

        <Title type='h1' className={style.add__title}>
          {object.title}
        </Title>

        {currentUser !== null && currentUser.status === true
          ? (
            <>
              <p className={style.add__text}>
                Загрузи фото на тему &laquo;{data?.property_topic_value ?? ''}
                &raquo;. После проверки фото будет добавлено в cписок работ
                конкурса.
              </p>
              <AddWorkForm url={url} contestId={contestId} />
            </>
            )
          : null}
        {currentUser !== null && currentUser.status === false
          ? (
            <div className={style.add__login}>
              <p>
                Для участия в конкурсе &laquo;
                {data?.property_topic_value ?? ''}
                &raquo; необходимо авторизоваться.
              </p>
              <Button
                size='extralarge'
                highlight
                href={authorization}
                className={style.add__loginbtn}
              >
                Вход/Регистрация
              </Button>
            </div>
            )
          : null}
        {currentUser === null ? <BlockSpinner /> : null}
      </Section>
    </Container>
  )
}

export default AddWork
